
export class SimplePaginationResource {
    total: number;
    page: number;
    startIndex: number;
    endIndex: number;

    constructor(map: SimplePaginationResource = {} as SimplePaginationResource) {
        this.total = map.total || null;
        this.page = map.page || null;
        this.startIndex = map.startIndex || null;
        this.endIndex = map.endIndex || null;
    }
}
